import { StoreState } from '../index';

export const blockingListSelector = (state: StoreState) => state.assortment.blockingAttributesInfo.blockingList;
